// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"90":"66609f051f89d108","709":"7f750e33a4014d1a","916":"4483883a840f75b0"}[chunkId] + ".js";
};